import { HTMLAttributes } from 'react';

import styles from './styles.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
    spacing?: number;
    align?: 'center' | 'flex-start' | 'flex-end'
    justify?: 'center' | 'flex-start' | 'flex-end' | 'space-between' ;
    fullWidth?: boolean;
    as?: 'div' | 'section' | 'article' | 'main' | 'nav';
}

function Row(props: Props) {
  const {
    spacing,
    align = 'center',
    fullWidth = false,
    justify = 'flex-start',
    as = 'div', className, ...rest
  } = props;
  const Component = as;
  return (<Component className={`${styles.row}
  ${styles[`width-${fullWidth ? 'full' : 'auto'}`]}
  ${styles[`align-${align}`]}
   ${styles[`justify-${justify}`]}
   ${className}`}
                     style={{ columnGap: spacing ? `${spacing}px` : '0' }}
                       {...rest} />
  );
}

export default Row;
